<template>
  <div class="maincont child" id="air_conditioner_setting_mod">
    <div class="ef--inner">
      <h2>空調機制御設定</h2>
      <div class="form" method="post" action>
        <div id="mod_air_conditioner_setting_form">
          <ul>
            <li>
              <label for="name" style="vertical-align: top">お客さま名</label>
              <div v-if="param.parent_name == '' || param.parent_name == null" style="display: inline-block">
                {{ param.name }}
              </div>
              <div v-else style="display: inline-block">
                [ {{ param.parent_name }} ] {{ param.name }}
              </div>
            </li>
            <br />

            <li>
              <label for="corpname" style="vertical-align: top">アカウントNo.</label>
              <div style="display: inline-block">
                {{ param.account }}
              </div>
            </li>
            <br />

            <li>
              <label for="parent_count" style="vertical-align:top;">空調機台数</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  id="parent_count"
                  class="vstxt"
                  v-model="param.parent_count"
                  v-validate="'numeric|min_value:1|max_value:999'"
                  name="parent_count"
                  data-vv-as="空調機台数"
                /> 台
                <div class="err_message">
                  {{ errors.first("parent_count") }}
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="child_count" style="vertical-align:top;">制御子機台数</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  id="child_count"
                  class="vstxt"
                  v-model="param.child_count"
                  v-validate="'numeric|min_value:1|max_value:999'"
                  name="child_count"
                  data-vv-as="制御子機台数"
                /> 台
                <div class="err_message">
                  {{ errors.first("child_count") }}
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="rating" style="vertical-align:top;">定格容量</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  id="rating"
                  class="vstxt"
                  v-model="param.rating"
                  v-validate="'numeric|min_value:1|max_value:9999'"
                  name="rating"
                  data-vv-as="定格容量"
                  ref="rating"
                /> kW
                <div class="err_message">
                  {{ errors.first("rating") }}
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="max_power_caution" style="vertical-align:top;">注意制御時の最大電力</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  id="max_power_caution"
                  class="vstxt"
                  v-model="param.max_power_caution"
                  v-validate="'required|numeric|min_value:1|max_value:9999|comp_max_power_caution:rating'"
                  name="max_power_caution"
                  data-vv-as="注意制御時の最大電力"
                  ref="max_power_caution"
                /> kW
                <div class="err_message">
                  {{ errors.first("max_power_caution") }}
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="max_power_limit" style="vertical-align:top;">限界制御時の最大電力</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  id="max_power_limit"
                  class="vstxt"
                  v-model="param.max_power_limit"
                  v-validate="'required|numeric|min_value:1|max_value:9999|comp_max_power_limit:max_power_caution'"
                  name="max_power_limit"
                  data-vv-as="限界制御時の最大電力"
                /> kW
                <div class="err_message">
                  {{ errors.first("max_power_limit") }}
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="rating_all" style="vertical-align:top;">定格容量(全体)</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  id="rating_all"
                  class="vstxt"
                  v-model="param.rating_all"
                  v-validate="'numeric|min_value:1|max_value:9999|comp_rating_all:rating'"
                  name="rating_all"
                  data-vv-as="定格容量(全体)"
                /> kW
                <div class="err_message">
                  {{ errors.first("rating_all") }}
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="reduced_power" style="vertical-align:top;">削減電力</label>
              <div style="display: inline-block">
                <input
                  type="text"
                  class="mtxt"
                  value="0"
                  disabled="true"
                  style="background-color:lightgray"
                /> ～ 
                <input
                  type="text"
                  class="mtxt"
                  v-model="param.reduced_power_lower"
                  disabled="true"
                  style="background-color:lightgray"
                /> kW
                <div class="err_message">
                </div>
                <br>

                <input
                  type="text"
                  id="reduced_power_lower"
                  class="mtxt"
                  v-model="param.reduced_power_lower"
                  v-validate="'required|numeric|min_value:2|max_value:998|comp_reduced_power_lower:reduced_power_upper'"
                  name="reduced_power_lower"
                  data-vv-as="削減電力(下限)"
                  ref="reduced_power_lower"
                /> ～ 
                <input
                  type="text"
                  id="reduced_power_upper"
                  class="mtxt"
                  v-model="param.reduced_power_upper"
                  v-validate="'required|numeric|min_value:2|max_value:998|comp_reduced_power_upper:reduced_power_lower'"
                  name="reduced_power_upper"
                  data-vv-as="削減電力(上限)"
                  ref="reduced_power_upper"
                /> kW
                <div class="err_message">
                  {{ errors.first("reduced_power_lower") }}
                </div>
                <div class="err_message" v-if="!errors.has('reduced_power_lower')">
                  {{ errors.first("reduced_power_upper") }}
                </div>
                <br>

                <input
                  type="text"
                  class="mtxt"
                  v-model="param.reduced_power_upper"
                  disabled="true"
                  style="background-color:lightgray"
                /> kW 以上
                <div class="err_message">
                </div>
              </div>
            </li>
            <br />

            <li>
              <label for="device_list" style="vertical-align:top;">制御機器</label>
              <div style="display: inline-block">
                <table class="devices-list" _fixedhead="rows:1;cols:0;">
                  <thead>
                    <tr>
                      <th style="width:10%;">No.</th>
                      <th style="width:75%;">機器ID</th>
                      <th style="width:15%;">
                        <a
                          class="detail"
                          v-bind:class="{ isDisabled: !addDevice }"
                          href="javascript:void(0);"
                          @click="onAddDevice()"
                          >追 加</a
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in param.device_list" v-bind:key="index">
                      <th>{{ index + 1 }}</th>
                      <td colspan="2">
                        <input
                          type="text"
                          :id="'device_' + index"
                          class="txt"
                          v-model.lazy="param.device_list[index].device_id"
                          v-validate="{
                            required: false,
                            regex: /^[a-zA-Z]{2}\d{6}$/,
                          }"
                          :name="'device_' + index"
                          data-vv-as="機器ID"
                          @blur="onDuplicate"
                        />
                        <div class="err_message">
                          {{ errors.first("device_" + index) }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style="border-bottom:none;"></td>
                      <td colspan="2" style="border-bottom:none;">
                        <div v-if="duplicateAlert == true">
                          <p style="color: red">
                            機器IDが重複しています。異なる機器IDを入力してください。
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </li>
          </ul>

          <div id="submit_area">
            <input
              type="button"
              id="submit"
              class="submit"
              value="登　録"
              @click="onUpdate"
              v-if="this.$store.state.loginType != 3"
            />
            <input
              type="button"
              id="cancel"
              class="cancel"
              value="キャンセル"
              @click="onCancel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */

// import Store from "../../store";
import Modal from "../Modal.vue";
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    parent_count: {
      numeric: () => '空調機台数の入力範囲は1～999です。',
      min_value: () => '空調機台数の入力範囲は1～999です。',
      max_value: () => '空調機台数の入力範囲は1～999です。'
    },
    child_count: {
      numeric: () => '制御子機台数の入力範囲は1～999です。',
      min_value: () => '制御子機台数の入力範囲は1～999です。',
      max_value: () => '制御子機台数の入力範囲は1～999です。'
    },
    rating: {
      numeric: () => '定格容量の入力範囲は1～9999です。',
      min_value: () => '定格容量の入力範囲は1～9999です。',
      max_value: () => '定格容量の入力範囲は1～9999です。'
    },
    max_power_caution: {
      required: () => '注意制御時の最大電力の入力範囲は1～9999です。',
      numeric: () => '注意制御時の最大電力の入力範囲は1～9999です。',
      min_value: () => '注意制御時の最大電力の入力範囲は1～9999です。',
      max_value: () => '注意制御時の最大電力の入力範囲は1～9999です。'
    },
    max_power_limit: {
      required: () => '限界制御時の最大電力の入力範囲は1～9999です。',
      numeric: () => '限界制御時の最大電力の入力範囲は1～9999です。',
      min_value: () => '限界制御時の最大電力の入力範囲は1～9999です。',
      max_value: () => '限界制御時の最大電力の入力範囲は1～9999です。'
    },
    rating_all: {
      numeric: () => '定格容量(全体)の入力範囲は1～9999です。',
      min_value: () => '定格容量(全体)の入力範囲は1～9999です。',
      max_value: () => '定格容量(全体)の入力範囲は1～9999です。'
    },
    reduced_power_lower: {
      required: () => '削減電力の入力範囲は2～998です。',
      numeric: () => '削減電力の入力範囲は2～998です。',
      min_value: () => '削減電力の入力範囲は2～998です。',
      max_value: () => '削減電力の入力範囲は2～998です。'
    },
    reduced_power_upper: {
      required: () => '削減電力の入力範囲は2～998です。',
      numeric: () => '削減電力の入力範囲は2～998です。',
      min_value: () => '削減電力の入力範囲は2～998です。',
      max_value: () => '削減電力の入力範囲は2～998です。'
    },
    device_0: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_1: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_2: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_3: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_4: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_5: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_6: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_7: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_8: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    },
    device_9: {
      regex: () => '機器IDのフォーマットが誤っています（英字2文字＋数値6桁）'
    }
  }
};
Validator.localize('ja', dict);

Validator.extend(
  'comp_max_power_caution',
  {
    getMessage: field => `定格容量より小さい値のみ入力可能です。`,
    validate (source, [destination]) {
      if (parseInt(source) >= parseInt(destination)) {
        return false;
      }
      return true;
    }
  },
  { hasTarget: true }
);
Validator.extend(
  'comp_max_power_limit',
  {
    getMessage: field => `注意制御時の最大電力より大きい値のみ入力可能です。`,
    validate (source, [destination]) {
      if (parseInt(source) <= parseInt(destination)) {
        return false;
      }
      return true;
    }
  },
  { hasTarget: true }
);
Validator.extend(
  'comp_rating_all',
  {
    getMessage: field => `定格容量以上の値のみ入力可能です。`,
    validate (source, [destination]) {
      if (parseInt(source) < parseInt(destination)) {
        return false;
      }
      return true;
    }
  },
  { hasTarget: true }
);
Validator.extend(
  'comp_reduced_power_lower',
  {
    getMessage: field => `削減電力(下限)には削減電力(上限)より小さい値のみ入力可能です。`,
    validate (source, [destination]) {
      if (parseInt(source) >= parseInt(destination)) {
        return false;
      }
      return true;
    }
  },
  { hasTarget: true }
);
Validator.extend(
  'comp_reduced_power_upper',
  {
    getMessage: field => `削減電力(下限)には削減電力(上限)より小さい値のみ入力可能です。`,
    validate (source, [destination]) {
      if (parseInt(source) <= parseInt(destination)) {
        return false;
      }
      return true;
    }
  },
  { hasTarget: true }
);

export default {
  name: "AirconSet",
  components: { Modal },

  data: function () {
    return {
      param: {},
      duplicateAlert: false,
      addDevice: true,
      reducedPowerLower: 0,
      reducedPowerUpper: 0
    };
  },
  mounted: function () {
    console.log(`mounted= %o`, this.$route.params.id);
    const self = this;

    this.$axios
      .get(`/srv/api/air_conditioner_setting/${this.$route.params.id}`, {
        withCredentials: true,
      })
      .then((response) => {
        if (typeof response.data == "object") {
          console.log(response.data);
          self.param = response.data;
          if (this.param.device_list.length == 0) {
            this.param.device_list = [{ device_kind: "0", device_id: "" }];
          }
        } else {
          // stinrgのときはセッションタイムアウト
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    onAddDevice: function () {
      let newItem = { device_id: "", device_kind: 0 };
      this.param.device_list.push(newItem);
      if (this.param.device_list.length < 10) {
        this.addDevice = true;
      } else {
        this.addDevice = false;
      }
    },
    onDuplicate() {
      const idList = [];
      this.param.device_list.forEach((device) => {
        idList.push(device.device_id);
      });
      const idList1 = [];
      idList.forEach((id) => {
        if (id != "") {
          idList1.push(id);
        }
      });
      if (!(idList1.length === new Set(idList1).size)) {
        this.duplicateAlert = true;
      } else {
        this.duplicateAlert = false;
      }
    },
    onUpdate: function() {
      console.log(this.param);
      if (this.duplicateAlert == false) {
        this.$validator.validateAll().then(result => {
          console.log(result);
          if (result) {
            const ans = confirm('入力した内容で設定しますか？');
            if (ans) {
              const self = this;
              this.$axios
                .put(
                  `/srv/api/air_conditioner_setting/${this.param.account}`,
                  this.param,
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  console.log(response.data);
                  const data = response.data;
                  if (data.status !== undefined) {
                    if (data.status === "success") {
                      self.$router.go(-1);
                    } else if (data.status === "duplicate"){
                      alert("他のユーザが使用している機器IDがあるため、登録できませんでした");
                    } else {
                      alert("登録できませんでした");
                    }
                  } else {
                    alert("登録できませんでした");
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
        });
      }
    },
    onCancel: function() {
      const ans = confirm('入力した内容を廃棄しますか？');
      if (ans) {
        this.$router.go(-1);
      }
    }
  },
};
</script>
